import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
// import conponents
import ViewDesc from './components/ViewDesc';
import BannerContent from './components/BannerContent';
import SwiperBanner from './components/SwiperBanner';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { LineSpace } from '@/componentsH5/ProductComponents';
import OtherList from '@/components/ProductCommon/OtherList';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300'],
    cis: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
};

export default function SolarPanel() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('400wrigidsolarpanel');
    const webpUrl = '/media/solarpanel_400w_rigid/h5/';

    if (typeof window !== 'undefined') {
        (window as any).ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap((window as any).ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            {/* banner */}
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['01.webp', '01.jpg'],
                            title: t('solarpanels_400w_rigid.title'),
                            des: t('solarpanels_400w_rigid.desc'),
                        },
                    ]}
                    config={{ isShowLogo: false, theme: 'white', height: 'calc(100vh - 0.5rem)', webpUrl }}
                />
            </div>

            <LineSpace height={1} background="transparent" />
            <BannerContent />

            {/* 详情 */}
            <div className="textImg textImg1">
                <LineSpace height={1} background="transparent" />
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: t('solarpanels_400w_rigid.rigid_solar_panels'),
                        desc: t('solarpanels_400w_rigid.rigid_solar_panels_desc'),
                        img_url: ['03.webp', '03.jpg'],
                    }}
                />
            </div>

            {/* 太阳能效率面板 */}
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        iconWidth: '0.26rem',
                        webpUrl,
                    }}
                    data={{
                        synopsis: t('solarpanels_400w_rigid.six_synopsis'),
                        desc: t('solarpanels_400w_rigid.six_des'),
                        img_url: ['04.webp', '04.jpg'],
                    }}
                />
            </div>

            {/* Weatherproof 面板 */}
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', imgHeight: '2.45rem', webpUrl }}
                    data={{
                        img_url: ['07.webp', '07.jpg'],
                        synopsis: t('solarpanels_400w_rigid.Weatherproof'),
                        desc: t('solarpanels_400w_rigid.Weatherproof_desc'),
                        tipBottom: t('solarpanels_400w_rigid.Weatherproof_tip'),
                    }}
                >
                    <div className="ip68">{t('solarpanels_400w_rigid.Weatherproof_ip68')}</div>
                    <div className="highly">{t('solarpanels_400w_rigid.Weatherproof_highly')}</div>
                    <div className="anti">{t('solarpanels_400w_rigid.Weatherproof_anti')}</div>
                </TextWithImage>
            </div>

            {/* 房车面板 面板 */}
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', imgHeight: '5rem', webpUrl }}
                    data={{
                        synopsis: t('solarpanels_400w_rigid.grid_solution'),
                        desc: t('solarpanels_400w_rigid.grid_solution_desc'),
                    }}
                >
                    <SwiperBanner
                        images={[{ imageSrc: '/product/solar_panel_400w_rigid_h5/10_1.jpg' }, { imageSrc: '/product/solar_panel_400w_rigid_h5/10_2.png' }]}
                    />
                </TextWithImage>
            </div>

            {/* compatible 面板 */}
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ position: 'top', imgWidth: '3.55rem', fullScreen: false, webpUrl }}
                    data={{
                        img_url: ['connectors.webp', 'connectors.jpg'],
                        synopsis: t('solarpanels_400w_rigid.compatible'),
                        desc: t('solarpanels_400w_rigid.compatible_desc'),
                    }}
                />
            </div>

            {/* 产品包装图 */}
            <LineSpace height={0.8} background="transparent" />
            <ViewDesc />

            <LineSpace height={1.2} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
